import React from 'react';

import * as Styled from './Textarea.styles';

function Textarea(props) {
  return <Styled.Textarea {...props} />;
}

export default Textarea;
